<template>
    <UiForm ref="form" :data="data" :rules="rules">
        <div class="row">
            <UiFormItem prop="coordinate" :label="$t('Site')">
                <UiStepsInput name="coordinate" v-model="data.coordinate" :width="408" :placeholder="cPlaceholder" @change="changeCoordinate" />
            </UiFormItem>

            <UiFormItem prop="ref" :label="$t('ReferenceBase')">
                <UiInput name="ref" v-model="data.ref" placeholder="" :width="216" :readonly="true" />
            </UiFormItem>

            <UiFormItem prop="alt" :label="$t('Mutant')">
                <UiInput name="alt" v-model="data.alt" :width="216" :placeholder="$t('MutantSequence')" @change="changeAlt" />
            </UiFormItem>
        </div>
    </UiForm>
</template>

<script lang="ts" setup>
import { UiForm, UiInput, UiFormItem, UiStepsInput } from "various-ui";
import { useComposable } from "./src/composable";

const emit = defineEmits<{ (event: "redraw", data: any): void }>();

const { refs, data, rules, methods } = useComposable(emit);

const { form, cPlaceholder } = refs;
const { changeCoordinate, changeAlt } = methods;

defineExpose({ init: methods.init, submit: methods.submit });
</script>

<style lang="less" scoped>
.ui-form {
    .row {
        display: flex;
        margin-top: 24px;
        justify-content: space-between;
    }
}
</style>
